import axios from 'axios';
import { generatePath } from 'react-router-dom';

import { RACE_CUSTOM_FIELDS_URL } from 'src/constants';
import { request, action } from 'src/utils';

import { CUSTOM_FIELDS_EQ_REQUEST } from '../constants';

import { mapOptions } from '../utils';

import { raceCustomFieldsStore } from '../stores';

import { raceDistancesStore } from '../../Shared';

class RaceCustomFields {
  @request({ action: CUSTOM_FIELDS_EQ_REQUEST })
  async getCustomFieldsRequests(id: number): Promise<any> {
    const url = generatePath(RACE_CUSTOM_FIELDS_URL, { id });
    return axios.get(url);
  }

  @action({ action: CUSTOM_FIELDS_EQ_REQUEST })
  async getCustomFields(id: number) {
    const [status, response] = await this.getCustomFieldsRequests(id);

    if (status) {
      raceCustomFieldsStore.set(mapOptions(response.data.data, raceDistancesStore.value || [], 'name'));
    }
  }
}

export const raceCustomFieldsService = new RaceCustomFields();
